import React, { useState } from 'react';
import { LinkTripCloseIcon, LinkRightArrowIcon } from './icons/svg';
import Alert from './alert';

const LinkTripsModel = ({ linkedCityData, searchParams, close }) => {

    const [startLinkToCity, setStartLinkToCity] = useState("");
    const [alertMsg, setAlertMsg] = useState(false);

    const linkProceed = () => {

        if (!startLinkToCity) {
            setAlertMsg(true);
        } else {

            var { departDate, IsSingleLady } = searchParams;

            var linkfromStopTocity = decodeURIComponent(startLinkToCity);
            //console.log(linkfromStopTocity);
            var fromCity = linkfromStopTocity.split("|")[1].trim();
            var fromCityId = linkfromStopTocity.split("|")[0].trim();
            var stopCity = linkfromStopTocity.split("|")[3].trim();
            var stopCityId = linkfromStopTocity.split("|")[2].trim();
            var toCity = linkfromStopTocity.split("|")[5].trim();
            var toCityId = linkfromStopTocity.split("|")[4].trim();

            var url = `/search?fromCity=${fromCityId}|${fromCity}&toCity=${stopCityId}|${stopCity}&departDate=${departDate}&returnDate=${departDate}&linkfromstoptocity=${linkfromStopTocity}&stophour=1&mode=roundtrip&src=h&stationInFromCity=&stationInToCity=&IsSingleLady=${IsSingleLady}`;
            window.location.href = url;
        }
    }

    return (
        <React.Fragment>
            <div className="link--layer">
                <div className="connection--route--wrapper">
                    <div className="route--header">Choose Link Trips<span className="closelink" onClick={close}><LinkTripCloseIcon /></span></div>
                    <div className="header-from-to-wrap">
                        <div className="start-from">
                            <div>Start From</div>
                            <div>
                                <LinkRightArrowIcon fillcolor="#01AEF0" />
                            </div>
                        </div>
                        <div className="stoping-at">
                            <div>Stopping At</div>
                            <div>
                                <LinkRightArrowIcon fillcolor="#01AEF0" />
                            </div>
                        </div>
                        <div className="going-to">
                            <div>Going To</div>
                            <div></div>
                        </div>
                    </div>
                    <div className="data--wrapper customscroll">
                        {linkedCityData && linkedCityData.length > 0 ?
                            linkedCityData.map((el, index) => {
                                var id = encodeURIComponent(el.FromCityID + '|' + el.FromCity + '|' + el.LinkCityID + '|' + el.LinkCity + '|' + el.ToCityID + '|' + el.ToCity);
                                return (
                                    <div key={'linkCityOpt'+index}  className="data-from-to-wrap" onClick={() => setStartLinkToCity(id)}>
                                        <div className={`radio-btn ${startLinkToCity == id ? 'active' : ''}`}>
                                            <div className={`radio-dot ${startLinkToCity == id ? 'active' : ''}`}></div>
                                        </div>
                                        <div className="start-from">
                                            <div className="startfrom--city">{el.FromCity}</div>
                                            <div>
                                                <LinkRightArrowIcon fillcolor="#666666" />
                                            </div>
                                        </div>
                                        <div className="stoping-at">
                                            <div>{el.LinkCity}</div>
                                            <div>
                                                <LinkRightArrowIcon fillcolor="#666666" />
                                            </div>
                                        </div>
                                        <div className="going-to">
                                            <div>{el.ToCity}</div>
                                            <div></div>
                                        </div>
                                    </div>
                                )
                            }) : <div className="data-from-to-wrap txtCt">No data found !</div>
                        }
                    </div>
                    <div className='proceed' onClick={() => linkProceed()}>PROCEED</div>
                </div>
            </div>
            {alertMsg && <Alert
                close={() => setAlertMsg(false)}
                msg={'Select link trip option !'}
            />}
        </React.Fragment>
    )
}

export default LinkTripsModel;